import GifDetailRoute from 'gif-detail/components/route'
import { VideoDetailRoute } from '../../../site/videos/route'
import Header from 'modules/header/components/header'
import { Component, Suspense } from 'react'
import { Provider } from 'react-redux'
import { Route, Switch } from 'react-router'
import { BrowserRouter } from 'react-router-dom'
import entryPoint from 'shared/components/entry-point-hoc'
import GTALogger from 'shared/components/gta-logger'
import ManagePageElements from 'shared/components/manage-page-elements'
import ReportOnSPA from 'shared/components/router/report-on-spa'
import ContextManagers from 'shared/context-managers'
import channelSelectorItems from 'shared/redux/channel-selector'
import { getDefaultStore } from 'shared/redux/init-store'
import routes from 'shared/routes'
import SiteContainer from '../../../site/site-container'
import Search from './route'

const store = getDefaultStore({ channelSelectorItems }, undefined)

@entryPoint(store)
export default class App extends Component {
    render() {
        // parse page data
        const { groupId, pageElements } = this.props
        const { user, showSearch, showBrowse, searchTerm } = this.props

        return (
            <Provider store={store}>
                <Suspense fallback={null}>
                    <SiteContainer>
                        <BrowserRouter>
                            <ContextManagers channel_access={user?.channel_access}>
                                <Header {...{ user, showSearch, showBrowse, searchTerm }} />
                                <ReportOnSPA />
                                <ManagePageElements pageElements={pageElements} />
                                <GTALogger />
                                <Switch>
                                    <Route
                                        {...routes.GIF_DETAIL}
                                        render={(props) => (
                                            <GifDetailRoute {...this.props} relatedGroupId={groupId} {...props} />
                                        )}
                                    />
                                    <Route
                                        {...routes.CLIPS_DETAIL}
                                        render={(props) => <VideoDetailRoute {...this.props} {...props} />}
                                    />
                                    <Route render={() => <Search {...this.props} />} />
                                </Switch>
                            </ContextManagers>
                        </BrowserRouter>
                    </SiteContainer>
                </Suspense>
            </Provider>
        )
    }
}
